import * as React from 'react';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import { Avatar, FormGroup, Stack, TextField } from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import YouTube from 'react-youtube';
import { ViewCarousel } from '@mui/icons-material';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const opts = {
    height: '300',
    width: '500',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
    //   autoplay: 1,
    },
  };

export default function YoutubeDialog(props) {
    const { open, setOpen, video } = props;

    const [videoId, setVideoId] = React.useState();
    
    React.useEffect(()=>{
        if( video ){
            let uri = video.link;
        
            let ext = uri.split("/");  
            let tp = null;
            if( ext.length > 1){
            tp = ext[ ext.length-1]
            }
            console.log( tp )
            if( tp === null)return;

            setVideoId(tp);
        }
    }, [video])
    const handleOk = () => {
        setOpen(false);
    };
    
    return (
        <BootstrapDialog
            onClose={() => setOpen(false)}
            aria-labelledby="Editor-pagina"
            open={open}
            // fullScreen
        >
            { video && <DialogTitle sx={{ m: 0, p: 2 }} id="Editor-pagina">
                {video.nome} - {video.palestrante} 
            </DialogTitle> }
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                {videoId && <YouTube 
                    videoId={videoId} 
                    opts={opts} 
                /> }
            </DialogContent>
            {/* <DialogActions>
                <Button autoFocus onClick={handleOk}>
                    Salvar
                </Button>
            </DialogActions> */}
            {/* <ImgCompDialog open={openImagem} setOpen={setOpenImagem} action={handleAvatar}/> */}
        </BootstrapDialog>
    )
}